module.exports = __webpack_public_path__ + "static/media/timed-bonus-open.1fb713d4.png";